import { yerelTarih } from './bicim.js';
/**
 * TARİH ARALIKLARI
 *
 * Kasa ve raporlar aynı tanımı kullanır. Değerler eski Nero Kasa'daki
 * aralık fonksiyonundan birebir alınmıştır — "Bu Ay" ayın tamamıdır
 * (bugüne kadar değil), "Son 7 Gün" bugün dahil yedi gündür.
 */
export const ARALIK_ANAHTARLARI = [
    'bugun', 'dun', 'son_7', 'bu_ay', 'gecen_ay', 'tek_gun', 'aralik', 'tumu',
];
export const ARALIK_ADI = {
    bugun: 'Bugün',
    dun: 'Dün',
    son_7: 'Son 7 gün',
    bu_ay: 'Bu ay',
    gecen_ay: 'Geçen ay',
    tek_gun: 'Tek gün',
    aralik: 'Tarih aralığı',
    tumu: 'Tümü',
};
/**
 * Seçilen aralığı gerçek tarihlere çevirir.
 * @param anahtar  aralık türü
 * @param tekGun   'tek_gun' seçiliyse kullanılacak gün
 * @param bas      'aralik' seçiliyse başlangıç
 * @param bit      'aralik' seçiliyse bitiş
 */
export function araligiCoz(anahtar, tekGun, bas, bit) {
    const simdi = new Date();
    const g = (d) => yerelTarih(d);
    if (anahtar === 'bugun')
        return { baslangic: g(simdi), bitis: g(simdi) };
    if (anahtar === 'dun') {
        const d = new Date(simdi);
        d.setDate(d.getDate() - 1);
        return { baslangic: g(d), bitis: g(d) };
    }
    if (anahtar === 'son_7') {
        const d = new Date(simdi);
        d.setDate(d.getDate() - 6);
        return { baslangic: g(d), bitis: g(simdi) };
    }
    if (anahtar === 'bu_ay') {
        return {
            baslangic: g(new Date(simdi.getFullYear(), simdi.getMonth(), 1)),
            bitis: g(new Date(simdi.getFullYear(), simdi.getMonth() + 1, 0)),
        };
    }
    if (anahtar === 'gecen_ay') {
        return {
            baslangic: g(new Date(simdi.getFullYear(), simdi.getMonth() - 1, 1)),
            bitis: g(new Date(simdi.getFullYear(), simdi.getMonth(), 0)),
        };
    }
    if (anahtar === 'tek_gun')
        return tekGun ? { baslangic: tekGun, bitis: tekGun } : {};
    if (anahtar === 'aralik') {
        const a = {};
        if (bas)
            a.baslangic = bas;
        if (bit)
            a.bitis = bit;
        return a;
    }
    return {};
}
/** Ekranda gösterilecek aralık açıklaması. */
export function aralikMetni(a) {
    if (!a.baslangic && !a.bitis)
        return 'Tüm kayıtlar';
    if (a.baslangic && a.bitis && a.baslangic === a.bitis)
        return a.baslangic;
    return `${a.baslangic ?? '…'} – ${a.bitis ?? '…'}`;
}
//# sourceMappingURL=aralik.js.map